import {BaseResponse} from './internal/baseresponse';
import {VersionList} from './internal/list/versionlist';


export class VersionListResult extends BaseResponse {
  data: VersionList;
}



// WEBPACK FOOTER //
// ./src/app/response/versionlistresult.ts